function SoftwareStatusController( __env, CommonService) {
  const ctrl = this;
  const env = __env;
  const getSelectedTrain = CommonService.getSelectedTrain;
  ctrl.$onInit = () => {
    ctrl.isTrainConnected = true;
    ctrl.hasHighSpeedTrain = env.profile !== 'lu';
    ctrl.wideTrains = env.profile === 'demo';
    ctrl.hasLinkToCarView = env.profile === 'demo';
    ctrl.hasClockAndMode = env.profile !== 'vale';
    
    ctrl.train = getSelectedTrain();
  }
}

angular
  .module('configuration-management.module')
  .controller('SoftwareStatusController', SoftwareStatusController);
